import { getVehicleTypes, getVehicleType, createVehicleType, updateVehicleType, deleteVehicleType } from "@/api/vehicleTypes";
import { createStore } from "vuex";
import { VehicleTypeState } from "../state";
import { VehicleType } from "../types";

export const vehicleTypeStore = createStore({
  state: {
    vehicleTypes: [],
    vehicleType: {} as any,
    vehicleTypeListTotal: 0,
    vehicleTypeListLoading: false
  },
  getters: {
    vehicleTypes: (state: VehicleTypeState) => state.vehicleTypes,
    vehicleType: (state: VehicleTypeState) => state.vehicleType,
    vehicleTypeListTotal: (state: VehicleTypeState) => state.vehicleTypeListTotal,
    vehicleTypeListLoading: (state: VehicleTypeState) => state.vehicleTypeListLoading
  },
  mutations: {
    setVehicleTypes(state: VehicleTypeState, payload: VehicleType[]) {
      state.vehicleTypes = payload
    },
    setVehicleType(state: VehicleTypeState, payload: VehicleType) {
      state.vehicleType = payload
    },
    clearVehicleType(state: VehicleTypeState) {
      state.vehicleType = {} as any
    },
    deleteVehicleTypeById(state: VehicleTypeState, payload: any) {
      state.vehicleTypes = state.vehicleTypes.filter((vehicleType: any) => {
        return String(vehicleType.id) !== String(payload.id)
      })
      state.vehicleTypeListTotal = state.vehicleTypeListTotal - 1
    },
    setVehicleTypeListTotal(state: VehicleTypeState, payload: number) {
      state.vehicleTypeListTotal = payload
    },
    setVehicleTypeListLoading(state: VehicleTypeState, payload: boolean) {
      state.vehicleTypeListLoading = payload
    }
  },
  actions: {
    async fetchVehicleTypes({ commit }, pagination) {
      commit('setVehicleTypeListLoading', true)
      const response = await getVehicleTypes(pagination)
      commit('setVehicleTypes', response.data.data)
      commit('setVehicleTypeListTotal', response.data.total)
      commit('setVehicleTypeListLoading', false)
    },
    async fetchVehicleType({ commit }, id) {
      if(this.state.vehicleTypeListLoading) return

      commit('setVehicleTypeListLoading', true)
      const response = await getVehicleType(id)
      commit('setVehicleType', response.data.data)
    },
    async createVehicleType({ commit }, data) {
      const response = await createVehicleType(data)
      commit('setVehicleType', response.data.data)
      return response.data.data.id
    },
    async updateVehicleType({ commit }, { id, data }) {
      const response = await updateVehicleType(id, data)
      commit('setVehicleType', response.data.data)
    },
    async deleteVehicleType({ commit }, id) {
      await deleteVehicleType(id)
      commit('deleteVehicleTypeById', { id: id })
    }
  },
})

export default vehicleTypeStore;
